import React from 'react';
import {Menu, MenuItem, useTheme} from '@mui/material';
import {translations} from 'presentation/translations-new/index';
import {ContextMenuProps} from './types';
import {baseStyle, menuId} from './constants';

const {exclude, edit} = translations['pt-br'].commons;
const {assignToDependent} = translations['pt-br'].privateFlow.bookingFlow.location;

export function DesktopContextMenu({
	anchorContextMenuEl,
	isMenuOpen,
	handleContextMenuClose,
	handleEdit,
	handleDelete,
	handleAssignToDependent,
	showAssignToDependent,
}: ContextMenuProps) {
	const {colors} = useTheme();

	return (
		<Menu
			anchorEl={anchorContextMenuEl}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			id={menuId}
			keepMounted
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			open={isMenuOpen}
			onClose={handleContextMenuClose}
			elevation={5}>
			<MenuItem
				onClick={() => {
					handleContextMenuClose();
					handleEdit();
				}}
				sx={{...baseStyle, color: colors.light.primary.main}}>
				{edit}
			</MenuItem>
			{showAssignToDependent && handleAssignToDependent && (
				<MenuItem
					onClick={() => {
						handleContextMenuClose();
						handleAssignToDependent();
					}}
					sx={{...baseStyle, color: colors.light.primary.main}}>
					{assignToDependent.menuLabel}
				</MenuItem>
			)}
			{handleDelete && (
				<MenuItem
					onClick={() => {
						handleContextMenuClose();
						handleDelete();
					}}
					sx={{...baseStyle, color: colors.light.error.main}}>
					{exclude}
				</MenuItem>
			)}
		</Menu>
	);
}
